import { fetchLineRemovalImpact } from "#modules/optimizations/infra/fetchLineRemovalImpact.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const lineRemovalImpactQuery = (lineIds: string[], enabled: boolean) => ({
  queryKey: queryKeys.optimizations.lineRemovalImpact(lineIds),
  queryFn: () => fetchLineRemovalImpact(lineIds),
  staleTime: 0,
  enabled: enabled && lineIds.length > 0,
});
